import React, { FC, useEffect, useState } from 'react'
import { Container, Grid, makeStyles, MenuItem, Select, Typography } from '@material-ui/core';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import LoadingButton from '../../components/buttons/LoadingButton';
import { useLocation } from 'react-router-dom';
import * as infomodul from '../../api/infomodul';
import { RouteLocationProps } from '../../routes/mobilbase';
import { DeviceMangeResult } from '../../api/mobilbase/models';
import { GalleryImage } from '../../api/infomodul/models';
import APIRequest from '../../components/helpers/APIRequest';
import DeviceLogDataFetcher from '../../components/helpers/DeviceLogDataFetcher';
import RequestRestart from '../../components/helpers/RequestRestart';
import APIRequestSetOutOfOrder from '../../components/helpers/APIRequestSetOutOfOrder';
import DeviceManageButtons from '../../components/buttons/DeviceManageButtons';
import DeviceManageDialog from '../../components/dialogs/DeviceManageDialog';

  const useStyles = makeStyles((theme) => ({
    paper: {
      marginTop: theme.spacing(3),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    grid: {
      width: '100%', // Fix IE 11 issue.
      marginTop: theme.spacing(3),
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
    },
    helperText: {  
      fontStyle: "italic",
      fontSize: "10px",
    }
  })); 

  type FormValues = {
    imageNumber: string;
  }


const DeviceManage: FC = () => {
  const classes = useStyles();
  const routeLocation = useLocation<RouteLocationProps>();
  const {selectedLocationId, selectedDeviceId, selectedDeviceName} = (routeLocation.state) ? routeLocation.state : new RouteLocationProps();
  const [images, setImages] = useState<GalleryImage[]>([]);
  const [isPending, setIsPending] = useState(false);
  const [runGetImages, setRunGetImages] = useState(true);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [runSetOutOfOrder, setRunSetOutOfOrder] = useState(false); 
  const [selectedImage, setSeletedImage] = useState(0);
  const [runRestart, setRunRestart] = useState(false); 
  const [restartType, setRestartType] = useState("restart");
  const [manageData, setManageData] = useState<DeviceMangeResult>({msg: ""});
  const [showMsg, setShowMsg] = useState(false)

  useEffect(() => {
    if (showMsg) {
      if (manageData.msg) {
        setMessage(manageData.msg)
      }
    }
  }, [showMsg, manageData.msg]);

  const { handleSubmit, control } = useForm<FormValues>({
    defaultValues: {
      imageNumber: "-1"
    }
  });

  const handleClick = async (name: string) => {
    if (!isPending) {
      setShowMsg(true);
      setRestartType(name);
      setRunRestart(true);
    }
  };

  const handleClose = () => {
    setManageData({msg: ""})
    setShowMsg(false);
    setMessage("");
    setError("");
  };

  const onSubmit: SubmitHandler<FormValues> = async data => {
    if (!isPending) {
      setShowMsg(true);
      setSeletedImage(+data.imageNumber);
      setRunSetOutOfOrder(true);
    }
  }

  const RequestOutOfOrderImages = () => {
    return (
      <APIRequest<GalleryImage[]> 
          run={runGetImages} 
          setRun={setRunGetImages}
          pending={isPending}
          setIsPending={setIsPending} 
          req={() => infomodul.getOutOfOrderImages({masterId: selectedLocationId, deviceId: selectedDeviceId})}
          setData={setImages}
      />
    );
  }

  return (
    <Container maxWidth={false}>
      <RequestOutOfOrderImages />

      <RequestRestart 
        run={runRestart}
        setRun={setRunRestart}
        isPending={isPending}
        setIsPending={setIsPending}
        selectedLocationId={selectedLocationId}
        selectedDeviceId={selectedDeviceId}
        restartType={restartType}
        setManageData={setManageData}
      />

      <APIRequestSetOutOfOrder
        run={runSetOutOfOrder}
        setRun={setRunSetOutOfOrder}  
        isPending={isPending}
        setIsPending={setIsPending}
        selectedLocationId={selectedLocationId}
        selectedDeviceId={selectedDeviceId}
        selectedImage={selectedImage}
        setManageData={setManageData}
      />

      <div className={classes.paper}>
        <Typography component="h1" variant="h5">
          Administration - {((selectedDeviceName) ? selectedDeviceName : "")}
        </Typography>
        <div className={classes.grid}>
          <Grid container spacing={2}>
          <Container maxWidth="xs">
          <Grid container spacing={2}>
           <Grid item xs={12}>
            <form onSubmit={handleSubmit(onSubmit)}>
              {/* <select name="imageNumber" ref={register} defaultValue="-1" > 
                <option  value="-1"> Standart billed </option >
                {images.map((v, index) => {
                  return <option  value={"" + v.imageNumber} key={index}>{v.imgDescription}</option >
                })}
                <option value="male">male</option> fullWidth variant="outlined"
                <option value="other">other</option>
              </select> */}

              <Controller
               name="imageNumber"
               as={
                  <Select fullWidth variant="outlined">
                   <MenuItem value={"-1"}> Standardbillede </MenuItem  >
                    {images.map((v, index) => {
                      return <MenuItem   value={"" + v.id} key={index}>{v.imgDescription}</MenuItem  >
                    })}
                  </Select>
                }
                control={control}
              />
              <div className={classes.helperText} style={{minHeight: "30px", display: "flex", justifyContent: "center", alignItems: "center"}}>
              <b>Husk at trykke på "Opdater" for at se ændringer i Hændelsesloggen.</b>
              </div>

              <LoadingButton pending={isPending} text={"Sæt i drift/ud af drift"} update={() => {}}/>
            </form>
            {/* <Button onClick={e => handleClick('I drift')} fullWidth variant="contained" color="primary">
                    Sæt i drift/ud af drift
                </Button> */}
          
          </Grid>          
          <DeviceManageButtons handleClick={handleClick} />
          </Grid> 
          </Container>
          <Grid item xs={12}>
           <Container maxWidth={false}>
            <div className={classes.paper}>
              <Typography component="h1" variant="h5">
                Hændelseslog - {((selectedDeviceName) ? selectedDeviceName : "INGEN VALGT")}
              </Typography>
              <div className={classes.grid}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <DeviceLogDataFetcher locationId={selectedLocationId} deviceId={selectedDeviceId}/>
                  </Grid>
                </Grid>
              </div>
            </div>
          </Container>
        </Grid>
      </Grid>
   </div>
    <DeviceManageDialog
      isOpen={(isPending && showMsg) || !!message || !!error}
      isPending={isPending}
      message={message}
      error={error}
      onClose={handleClose}
    />
   </div>
  </Container>
 );
}

export default DeviceManage;